/**
 * @description: 账单明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="zm-report">
        <div class="zm-list" v-show="!showZmDet">
            <p class="p-hint">注：1、统计的数据已扣除退款金额和退货数量。2、当天营业数据就只能单个营业日</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="zmTime">
                        <input type="text" class="form-control laydate-icon" v-model="zmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="zmEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zmShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">消费包厢:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zm_bill_box" data-placeholder="请选择消费包厢" disabled>
                    </select>
                </div>
                <label class="list-label-3">账单号:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入账单号" v-model="zm_bill_no">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">包厢区域:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择包厢区域" v-model="zm_room_area" ref="zm_room_area" readonly @click="zmRoomAreaFun()">
                    <span class="selection-clear" @click="clear_input">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-4">包厢类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢类型" ref="zmBoxType"></select>
                </div>
                <label class="list-label-4">会员卡号:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入会员卡号" v-model="zm_vip_card">
                </div>
                <label class="list-label-3">预订人:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入预订人" v-model="zm_book_name">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zm_admin"></select>
                </div>
                <label class="list-label-3">轮台人:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入轮台人" v-model="zm_ltr_name">
                </div>
                <label class="list-label-2">班次:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="banci" data-placeholder="请选择班次"></select>
                </div>
                <label class="list-label-4">价格策略:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="bill_price_rule" data-placeholder="请选择价格策略"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getZmList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getZmExportSet">导出</button>
                </div>
            </div>
            <!-- <div class="total-txt">实收金额合计：{{income}}</div> -->
            <div class="zm-table">
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    :data="eleTableData"
                    @sort-change="listOrder">
                    <el-table-column
                        v-for="(item, index) in elmColumns"
                        :fixed="item.fixed"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width"
                        :sortable="(item.prop == 'room_name' || item.prop == 'start_time' || item.prop == 'end_time' || item.prop =='book_admin_name')?'custom':false">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="toZmDet(scope.row.bill_no)">详情</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="zm_page"
                    :total="zm_list_total"
                    @current-change="getZmList">
                </el-pagination>
                <div class="check-sum" @click="doSum">查看合计金额</div>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="zmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='zmExport_allcheck' @click='zmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in zmExport_checkData" :key="item.key">
                            <input type="checkbox" v-model='zmExport_checkModel' :value="item.key">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='zmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='zmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 包厢区域弹窗 -->
            <div class="ele-hide" ref="zm_area_alert">
                <div class="sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='zm_area_allcheck' v-on:click='zmAreaCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in zm_area_data" :key="item.id">
                            <input type="checkbox" v-model='zm_area_model' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 账单详情 -->
        <div class="zm-det" v-show="showZmDet">
            <billDetail ref="zm_bill_det" @backBdwPre="showZmDet = false"></billDetail>
        </div>
        <!-- 合计弹窗 -->
        <div class="sum-pop ele-hide" ref="sum_pop">
            <el-table
                v-loading="pop_loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                style="width:100%"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="sum_table"
                :key="sumTableKey">
                <el-table-column :prop="item.prop" 
                    :label="item.name" 
                    v-for="item in sum_column_arr"
                    :key="item.name"
                >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                showZmDet: false,
                zmStartTime: "",
                zmEndTime: "",
                zm_bill_no: "",
                zm_room_area: '',
                zm_area_allcheck: false,
                zm_c_area_allcheck: false,
                zm_area_model: [],
                zm_area_data: [],
                zm_vip_card: '',
                zm_book_name: '',
                zm_ltr_name: '',
                zm_order_by: 'start_time_desc', //book_asc: 按预订人正序，book_desc: 按预订人倒序，room_name：按包厢名排序，start_time_asc：开放时间正序，start_time_desc：开放时间倒序，end_time_asc：关房时间正序，end_time_desc：关房时间倒序
                zmExport_allcheck: false,
                c_zmExport_allcheck: false,
                zmExport_checkModel: [],
                zmExport_checkData: [],
                zmExport_type: 1,
                zmColumns: [],
                zm_list_total: 0,
                zm_page: 1,
                eleTableData: [],
                elmColumns: [],
                sum_table: [],
                sum_column_arr: [],
                pop_loading: false,
                sumTableKey: Math.random(),
                isSuming: false,
                book_export_log_list: [], // 预约导出记录
            }
        },
        components: {
            "billDetail": billDetail
        },
        watch: {
            zm_room_area: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.zm_room_area).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.zm_room_area).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            zm_area_model: {
                handler: function (val, oldVal) {
                    if(this.zm_area_model.length >= this.zm_area_data.length) {
                        this.zm_area_allcheck = true;
                        this.zm_c_area_allcheck = true;
                    } else {
                        this.zm_area_allcheck = false;
                        this.zm_c_area_allcheck = false;
                    }
                },
                deep: true
            },
            zmExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.zmExport_checkModel.length >= this.zmExport_checkData.length) {
                        this.zmExport_allcheck = true;
                        this.c_zmExport_allcheck = true;
                    } else {
                        this.zmExport_allcheck = false;
                        this.c_zmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.zmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.zmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.zmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.zmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.zmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.zmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.zmTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    _this.zmStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.zmEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.zmShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                // 操作人
                                _this.getAdminData(e.params.data.id);
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.zm_bill_box).html("");
                                    $(_this.$refs.zm_bill_box).prop("disabled", true);

                                    _this.zm_room_area = '';
                                    _this.zm_area_model = [];
                                    $(_this.$refs.zm_room_area).prop('disabled', true);
                                    // 包厢类型
                                    $(_this.$refs.zmBoxType).val('').trigger('change');
                                    $(_this.$refs.zmBoxType).prop('disabled', true);

                                    return;
                                }
                                $(_this.$refs.zm_bill_box).prop("disabled", false);
                                _this.getRoomdata(e.params.data.id);

                                $(_this.$refs.zm_room_area).prop('disabled', false);
                                _this.zm_room_area = '';
                                _this.zm_area_model = [];
                                _this.getRoomAreaData(e.params.data.id);
                                // 包厢类型
                                $(_this.$refs.zmBoxType).prop('disabled', false);
                                _this.getBoxType(e.params.data.id);
                                // 班次
                                $(_this.$refs.banci).prop("disabled", false);
                                _this.getBanci(e.params.data.id)
                                // 价格策略
                                $(_this.$refs.bill_price_rule).prop("disabled", false);
                                _this.getBillPriceRule(e.params.data.id)
                                _this.setShopDefaultTime(e.params.data.id)
                            });

                            $(_this.$refs.zmShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            $(_this.$refs.zm_bill_box).prop("disabled", false);
                            _this.getRoomdata(data.response.result[1].id);
                            $(_this.$refs.zm_room_area).prop('disabled', false);
                            _this.getRoomAreaData($(_this.$refs.zmShop).val());
                            // 包厢类型
                            $(_this.$refs.zmBoxType).prop('disabled', false);
                            _this.getBoxType($(_this.$refs.zmShop).val());
                            // 班次
                            $(_this.$refs.banci).prop("disabled", false);
                            _this.getBanci($(_this.$refs.zmShop).val())
                            // 价格策略
                            $(_this.$refs.bill_price_rule).prop("disabled", false);
                            _this.getBillPriceRule($(_this.$refs.zmShop).val())
                            // 操作人
                            _this.getAdminData(data.response.result[1].id);

                            _this.getZmList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢号
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.zm_bill_box).html("");
                            $(_this.$refs.zm_bill_box).select2({
                                data: roomDatas,
                                minimumResultsForSearch: 1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 获取包厢区域
            getRoomAreaData: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.zm_area_data = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢类型
            getBoxType: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getRoomType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result.data, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            // 初始化
                            $(_this.$refs.zmBoxType).html('');
                            $(_this.$refs.zmBoxType).select2({
                                data: arr,
                                language: "zh-CN",
                                minimumResultsForSearch: -1,
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取操作人数据
            getAdminData: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.zm_admin).html("");
                            $(_this.$refs.zm_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取门店班次
            getBanci: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "field": "shift_setting" // 查询的门店参数名称
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfig",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v, text: v });
                            });
                            $(_this.$refs.banci).html('');
                            $(_this.$refs.banci).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            // 获取账单价格策略列表
            getBillPriceRule: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getBillGoodsPriceRule",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.bill_price_rule).html('');
                            $(_this.$refs.bill_price_rule).select2({
                                data: arr,
                                minimumResultsForSearch: 1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },


            // 清空多选
            clear_input: function() {
                this.zm_room_area = "";
                this.zm_area_model = [];
            },
            // 包厢区域全选
            zmAreaCheckedAll: function() {
                let _this = this;
                _this.zm_area_allcheck = _this.zm_c_area_allcheck;
                if(!_this.zm_area_allcheck) { // 实现全选
                    _this.zm_area_model = [];
                    _this.zm_area_data.forEach(function(item) {
                        _this.zm_area_model.push(item.id);
                    });
                } else { // 实现反选
                    _this.zm_area_model = [];
                }
            },
            // 选择包厢区域
            zmRoomAreaFun: function() {
                let _this = this;

                let zm_c_area_model = _this.zm_area_model;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['支付类型', true],
                    area: ['300px', ''], // 宽高
                    content: $(_this.$refs.zm_area_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.zm_room_area != "") {
                            _this.zm_area_model = zm_c_area_model;
                            return;
                        }
                        _this.zm_room_area = [];
                    }
                }, function() {
                    let areaTxts = [];
                    _this.zm_area_data.forEach(function(item) {
                        _this.zm_area_model.forEach(function(item2) {
                            if(item.id == item2) {
                                areaTxts.push(item.name);
                            }
                        });
                    });
                    _this.zm_room_area = areaTxts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.zm_room_area != "") {
                        _this.zm_area_model = zm_c_area_model;
                        return;
                    }
                    _this.zm_area_model = [];
                });
            },
            // 获取账单列表数据
            getZmList: function(page) {
                let _this = this,
                    room_area = [];
                if(_this.zm_area_model.length != '0' && !_this.zm_area_allcheck) {
                    room_area = _this.zm_area_model;
                }
                _this.zm_page = page
                _this.loading = true;
                Vue.axios.post('FinanceReport/billDetail', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.zmStartTime,
                            "end_date": _this.zmEndTime,
                            "shop_id": $(_this.$refs.zmShop).val(),
                            "room_id": $.trim($(_this.$refs.zm_bill_box).val()),
                            "room_area": room_area,
                            "room_type": $.trim($(_this.$refs.zmBoxType).val()),
                            "bill_no": _this.zm_bill_no,
                            "admin_id": $.trim($(_this.$refs.zm_admin).val()),
                            "vip_card": _this.zm_vip_card,
                            "book_admin_name": _this.zm_book_name,
                            "stand_admin_name": _this.zm_ltr_name,
                            "order_by": _this.zm_order_by,
                            "shift_name": $.trim($(_this.$refs.banci).val()),
                            "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == '1') {
                            _this.zm_list_total = Number(res.data.response.result.count);
                            _this.elmColumns = [];
                            _this.zmExport_checkData = [];
                            for(let [key, value] of Object.entries(res.data.response.result.column_arr)) {
                                if(key == 'start_time' || key == 'end_time' || key == 'order_title' || key == 'room_name' || key == 'book_admin_name') {
                                    _this.elmColumns.push({ prop: key, label: value, width: '110' });
                                } else if(key == 'bill_no' || key == 'vip_card') {
                                    _this.elmColumns.push({ prop: key, label: value, width: '120' });
                                } else {
                                    _this.elmColumns.push({ prop: key, label: value, width: 'auto' });
                                }
                                _this.zmExport_checkData.push({ key: key, name: value });
                            }
                        }
                        _this.eleTableData = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 表格排序
            listOrder(col) {
                console.log(col)
                if (col.prop == 'start_time') {
                    if (col.order == 'ascending') {
                        this.zm_order_by = 'start_time_asc'
                    }else if (col.order == 'descending') {
                        this.zm_order_by = 'start_time_desc'
                    }else {
                        this.zm_order_by = ''
                    }
                }else if (col.prop == 'end_time') {
                    if (col.order == 'ascending') {
                        this.zm_order_by = 'end_time_asc'
                    }else if (col.order == 'descending') {
                        this.zm_order_by = 'end_time_desc'
                    }else {
                        this.zm_order_by = ''
                    }
                }else if (col.prop == 'room_name') {
                    this.zm_order_by = 'room_name'
                } else if (col.prop == 'book_admin_name') {
                    if (col.order == 'ascending') {
                        this.zm_order_by = 'book_asc'
                    }else if (col.order == 'descending') {
                        this.zm_order_by = 'book_desc'
                    }else {
                        this.zm_order_by = ''
                    }
                }
                this.getZmList(1)
            },
            // 详情
            toZmDet(bill_no) {
                this.$refs.zm_bill_det.getBdwDetail(bill_no);
                this.showZmDet = true;
                // console.log(row);
            },
            // 获取导出设置
            getZmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/billDetailExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.zmExport_checkModel = data.response.result.export_fields;
                                console.log(_this.zmExport_checkModel);
                                _this.zmExport_type = data.response.result.export_type;
                            } else {
                                _this.zmExport_checkData.forEach(function(item) {
                                    _this.zmExport_checkModel.push(item.key);
                                });
                                _this.zmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.zmExport_alert)
                }, function() {
                    _this.checkExport();
                });
            },
            // 导出字段全选
            zmExportCheckedAll: function() {
                let _this = this;
                _this.zmExport_allcheck = _this.c_zmExport_allcheck;
                if(!_this.zmExport_allcheck) { // 实现全选
                    _this.zmExport_checkModel = [];
                    _this.zmExport_checkData.forEach(function(item) {
                        _this.zmExport_checkModel.push(item.key);
                    });
                } else { // 实现反选
                    _this.zmExport_checkModel = [];
                }
            },

            // 检查导出状态
            checkExport() {
                let _this = this,
                    room_area = [];
                if (_this.zm_area_model.length != '0' && !_this.zm_area_allcheck) {
                    room_area = _this.zm_area_model;
                }
                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'billDetail',
                        "param": {
                            "page": _this.zm_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.zmStartTime,
                            "end_date": _this.zmEndTime,
                            "shop_id": $(_this.$refs.zmShop).val(),
                            "room_id": $.trim($(_this.$refs.zm_bill_box).val()),
                            "room_area": room_area,
                            "room_type": $.trim($(_this.$refs.zmBoxType).val()),
                            "bill_no": _this.zm_bill_no,
                            "admin_id": $.trim($(_this.$refs.zm_admin).val()),
                            "vip_card": _this.zm_vip_card,
                            "book_admin_name": _this.zm_book_name,
                            "stand_admin_name": _this.zm_ltr_name,
                            "order_by": _this.zm_order_by,
                            "shift_name": $.trim($(_this.$refs.banci).val()),
                            "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.exportZmList();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this,
                    shop_id = $(_this.$refs.zmShop).val(),
                    room_id = $.trim($(_this.$refs.zm_bill_box).val()),
                    room_area = [];
                if (_this.zm_area_model.length != '0' && !_this.zm_area_allcheck) {
                    room_area = _this.zm_area_model;
                }
                let export_fields = JSON.stringify(_this.zmExport_checkModel);

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'billDetail',
                        "param": {
                            "page": _this.zm_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.zmStartTime,
                            "end_date": _this.zmEndTime,
                            "shop_id": shop_id,
                            "room_id": room_id,
                            "room_area": room_area,
                            "room_type": $.trim($(_this.$refs.zmBoxType).val()),
                            "bill_no": _this.zm_bill_no,
                            "admin_id": $.trim($(_this.$refs.zm_admin).val()),
                            "vip_card": _this.zm_vip_card,
                            "book_admin_name": _this.zm_book_name,
                            "stand_admin_name": _this.zm_ltr_name,
                            "order_by": _this.zm_order_by,
                            "shift_name": $.trim($(_this.$refs.banci).val()),
                            "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            // 导出账单列表
            exportZmList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.zmShop).val(),
                    room_id = $.trim($(_this.$refs.zm_bill_box).val()),
                    room_area = [];
                if(_this.zm_area_model.length != '0' && !_this.zm_area_allcheck) {
                    room_area = _this.zm_area_model;
                }
                let export_fields = JSON.stringify(_this.zmExport_checkModel);

                window.location.href = Vue.ctUrl + "FinanceReport/billDetailExport?" +
                    "start_date=" + _this.zmStartTime +
                    "&end_date=" + _this.zmEndTime +
                    "&shop_id=" + shop_id +
                    "&room_id=" + room_id +
                    "&room_area=" + room_area +
                    "&room_type=" + $.trim($(_this.$refs.zmBoxType).val()) +
                    "&bill_no=" + _this.zm_bill_no +
                    "&admin_id=" + $.trim($(_this.$refs.zm_admin).val()) +
                    // "&no_ml_income=" + $(_this.$refs.zm_ismoling).val() +
                    "&vip_card=" + _this.zm_vip_card +
                    "&book_admin_name=" + _this.zm_book_name +
                    "&stand_admin_name=" + _this.zm_ltr_name +
                    "&order_by=" + _this.zm_order_by +
                    "&shift_name=" + $.trim($(_this.$refs.banci).val()) +
                    "&bill_goods_price_rule_id=" + $.trim($(_this.$refs.bill_price_rule).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.zmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },

            // 查看合计金额
            doSum() {
                if(this.isSuming) {
                    return;
                }
                this.isSuming = true;
               
                const _this = this;
                _this.pop_loading = true;
                Vue.axios.post('FinanceReport/getBillDetailSumAmount', {})
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.sum_column_arr = []
                        _this.sum_table = []
                        for(let [key, value] of Object.entries(res.data.response.result.column_arr)) {
                                _this.sum_column_arr.push({ prop: key, name: value });
                            }
                        _this.sum_table.push(res.data.response.result.data);
                        _this.sumTableKey = Math.random();

                        layer.confirm('', {
                            skin: 'public-alert-skin',
                            type: 1,
                            btn: [], // 按钮
                            title: ['合计', true],
                            area: ['1000px', ''], // 宽高
                            content: $(_this.$refs.sum_pop),
                            offset: '260px',
                        });
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                    _this.pop_loading = false;
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
                .finally(() => {
                    this.isSuming = false;
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    .check-sum {
        margin-top: -30px;
        margin-left: 20px;
        color: #409EFF;
        cursor: pointer;
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>